export default __webpack_public_path__ + "static/media/project-img-7.79c11f5d.png";